import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import { adminTextFieldSx, inputLabelSx } from "../shared/styles";

function AdminLabeledField({ label, ...textFieldProps }) {
  return (
    <Box sx={{ mb: "16px", "&:last-child": { mb: 0 } }}>
      <Typography component="label" sx={{ ...inputLabelSx, mb: 0, display: "block" }}>
        {label}
      </Typography>
      <TextField
        fullWidth
        size="small"
        sx={{ ...adminTextFieldSx, mt: "8px" }}
        {...textFieldProps}
      />
    </Box>
  );
}

export default AdminLabeledField;
